import { useContext } from "react";
import { init } from "../i18n/i18n";
import LocaleContext from "../context/LocaleContext";
var useI18n = function useI18n() {
  var theContext = useContext(LocaleContext);
  if (theContext.$i18n) {
    return theContext.$i18n;
  }
  return init({
    locale: theContext.locale,
    lang: theContext.lang
  });
};
export default useI18n;